import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './styles/theme.less'
import Clarity from '@microsoft/clarity'

if (process.env.REACT_APP_ENV === 'prod' && process.env.REACT_APP_CLARITY_PROJECT_ID) {
  Clarity.init(process.env.REACT_APP_CLARITY_PROJECT_ID)
  console.log('Clarity initialized for production environment')
}


const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
